
import { defineComponent } from 'vue';
import SearchModal from '@/components/widgets/SearchModal.vue'
// TODO this is not implemented at all 
// this should return a deliveryaddress id from the search modal

// we have a customerId from the previous step
// from that we can lookup any service contract it belongs to, and from that get the deliveryaddres. 
// there can be multiple delivery addresses to each service agreement
export default defineComponent({
    emits: [
        'click:ok',
        'click:cancel',
    ],
    components: {
        SearchModal
    },
    async mounted() {
    
    },
    props: {
        display: {
            type: Boolean,
            default: false
        },
        primaryKey: {
            type: String,
            default: "DeliveryAddressID" 
        },
        excludedKeys: {
            type: Array,
            default: () => ['DeliveryAddressID']
        },
        CustomerID: {
            type: Number,
            default: null
        },
        text: {
            type: String,
            default: 'Hent fra Kunde'
        },
        title: {
            type: String,
            default: 'Find kunde'
        },
        enableX: {
            type: Boolean,
            default: false
        },
        okBtn: {
            type: String,
            default: 'Vælg'
        },
        cancelBtn: {
            type: String,
            default: 'Fortryd'
        },
    },
    computed: {
        searchPath() {
            console.log(this.CustomerID);
            if (this.CustomerID) {
                return `delivery-address/search/${this.CustomerID}`;
            } else { 
                return `delivery-address/search`;
            }
        }
    },
    methods: {
        ok(address: any) { 
            console.log(address);
            this.$emit('click:ok', address);
        },
        cancel() { 
            this.$emit('click:cancel');    
        }
    },
});
